module.exports = __webpack_public_path__ + "images/21_blitz_phone-02c689bf0226496f7d2f3ed376702d30.png";